import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { OpportunitiesForYouSuccessScreenModel } from 'src/app/shared/model/opportunities-for-you-success.model';
import { ReturnHomeService } from '../../../app/shared/service/comunicator-native/return-home/return-home';
import { AnalyticsGA4PageService } from '../../../app/shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { CpHighLightButton } from 'src/app/shared/model/cp-high-light-button';
import { TagGa4Enum } from '../../../app/shared/enums/tag-ga4.enum';

@Component({
  selector: 'app-new-products',
  templateUrl: './new-products.component.html',
  styleUrls: ['./new-products.component.scss']
})
export class NewProductsComponent implements OnInit {

  public data: OpportunitiesForYouSuccessScreenModel;

  constructor(
    public router: NavController, 
    private returnHomeService: ReturnHomeService, 
    private route: ActivatedRoute,
    private analyticsGA4PageService: AnalyticsGA4PageService,
  ) {}
  
  public ngOnInit(): void {
    this.route.queryParams.subscribe(params => this.data = JSON.parse(params['dataParams']));
    this.sendTrackGA4LoadPage();
  }

  public endJourneyNative(): void {
    this.sendTrackGA4Click();
    this.returnHomeService.returnCommunicator();
  }

  public redirecionarNativoION(data: CpHighLightButton) {
    this.sendTrackGA4Click(data.texto)
    //TODO: adicionar rota de deeplink para IOS
    document.location.href = data.rota;
  }

  private sendTrackGA4LoadPage(): void {
    const paramDefault = {
      event_name: TagGa4Enum.EVENT_SCREEN_VIEW,
      custom_path: TagGa4Enum.PATH_CONHECA_PRODUTOS,
      implementation_team: TagGa4Enum.IMPLEMENTATION_TEAM,
    };

    if (this.data.isActive === true) {
      const paramComplementary = {
        teste_id: this.data.test_id, 
        test_variant: this.data.test_variant,
      };

      this.analyticsGA4PageService.sendTrackGA4(paramDefault, paramComplementary);
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefault);
  }

  private sendTrackGA4Click(detail: string = 'fechar'): void {
    const paramDefault = {
      event_name: TagGa4Enum.EVENT_CLICK,
      custom_path: TagGa4Enum.PATH_CONHECA_PRODUTOS,
      implementation_team: TagGa4Enum.IMPLEMENTATION_TEAM,
      detail: detail,
    };

    if (this.data.isActive === true) {
      const paramComplementary = {
        teste_id: this.data.test_id, 
        test_variant: this.data.test_variant,
      };

      this.analyticsGA4PageService.sendTrackGA4(paramDefault, paramComplementary);
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefault);
  }

}
